<template>
  <b-modal
    v-model="visible"
    title="Correlated xTend Traffic"
    size="xl"
    hide-footer
    scrollable
    @hidden="$emit('close')"
  >
    <div v-if="hasData" >
      <div class="mb-1">
        <strong> Process(es): </strong>
        <span>{{ (processes || []).length ? processes.join(', ') : 'N/A' }}</span>
      </div>
      <div>
        <strong> Record(s): </strong>
        <div
          v-for="(record, index) in trafficRecords"
          :key="index"
          class="mb-1 rounded"
        >
          <pre class="m-0 record-pre">{{ JSON.stringify(record) }}</pre>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      No correlated xTend traffic available.
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    commId: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      processes: [],
      trafficRecords: [],
      visible: true,
    };
  },
  computed: {
    xtendTrafficUrl() {
      return '/security/xtendtraffic.json';
    },
    xtendTrafficParams() {
      return {
        params: {
          time: this.time,
          commId: this.commId,
        },
      };
    },
    hasData() {
      return this.loaded && this.trafficRecords && this.trafficRecords.length > 0;
    },
  },
  mounted() {
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.$http.get(this.xtendTrafficUrl, this.xtendTrafficParams)
        .then((response) => {
          this.processes = response.data.processes;
          this.trafficRecords = response.data.traffic;
        })
        .finally(() => { this.loaded = true; });
    },
  },
};
</script>
<style>
.record-pre {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}
</style>
